export class Translate {
}
